var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{ref:"mainapp",class:_vm.appClasses,style:(_vm.styles)},[_c(_vm.layout,{ref:_vm.layout,tag:"component"}),_c('app-snackbar',{ref:"snackbar"}),_c('confirm-dialog',{ref:"confirm"}),_c('app-loader-dialog',{ref:"loader"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }